var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { SliceMainSectionLayout } from './slice-main-section-layout';
import { DottedLine } from '../elements/dotted-line';
import { IconTextValue } from '../elements/icon-text-value';
import { LinkButton } from '../elements/link-button';
import { ChevronRightThinIconGlyph, EmailFilledIconGlyph, LinkedinFilledIconGlyph, PhoneFilledIconGlyph, ThreadsFilledIconGlyph, TwitterFilledIconGlyph } from '@shapeable/icons';
import { useLang } from '../hooks/use-lang';
import { useLink } from '../hooks/use-link';
import { usePageEntity } from '../hooks/use-page-entity';
var cls = classNames('slice-contact-info');
export var SliceContactInfoDefaultProps = {
  colors: {
    fill: 'line',
    border: 'line',
    text: 'line',
    hover: {
      fill: 'mid',
      border: 'mid',
      text: 'mid'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(16))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n\n    ", "\n  "])), function (_a) {
    var hasContactInfo = _a.hasContactInfo;
    return hasContactInfo && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      gap: ", ";\n    "], ["\n      gap: ", ";\n    "])), theme.UNIT(4));
  })
});
var TextValueStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 300;\n    font-size: 1em;\n  "], ["\n    color: ", ";\n    font-weight: 300;\n    font-size: 1em;\n  "])), theme.COLOR('strong'))
});
var HeadStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: ", ";\n  "])), theme.UNIT(4))
});
var WebsiteButtonStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    gap: ", ";\n  "])), theme.UNIT(4))
});
var DownloadStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var PlatformConnectStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceContactInfo',
  Container: styled(SliceMainSectionLayout)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Head: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  TextValue: styled(IconTextValue)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TextValueStyles),
  WebsiteButton: styled(LinkButton)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), WebsiteButtonStyles),
  Buttons: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  Download: styled(LinkButton)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), DownloadStyles),
  PlatformConnect: styled(LinkButton)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), PlatformConnectStyles)
};
export var SliceContactInfo = function (props) {
  var componentProps = useComponentProps(My.NAME, SliceContactInfoDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity,
    colors = componentProps.colors;
  var activeEntity = usePageEntity();
  var sliceEmail = entity.email,
    slicePhone = entity.phone,
    sliceWebsiteUrl = entity.websiteUrl,
    sliceLinkedin = entity.linkedin,
    sliceTwitter = entity.twitter,
    sliceThreads = entity.threads;
  var email = sliceEmail || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.email);
  var phone = slicePhone || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.phone);
  var websiteUrl = sliceWebsiteUrl || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.websiteUrl) || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.url);
  var linkedin = sliceLinkedin || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.linkedin);
  var twitter = sliceTwitter || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.twitter);
  var threads = sliceThreads || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.threads);
  var hasWebsite = !!websiteUrl;
  var hasContactInfo = email || phone || hasWebsite || linkedin || twitter || threads;
  var Link = useLink().Link;
  var t = useLang();
  // leave vCard WITHOUT indentation to avoid whitespace in the file
  var downloadVCard = function () {
    var vCard = "\nBEGIN:VCARD\nVERSION:3.0\nFN:".concat((activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.name) || 'Unknown', "\nTEL;TYPE=WORK,VOICE:").concat(phone || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.phone) || '', "\nEMAIL:").concat(email || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.email) || '', "\nURL:").concat(websiteUrl || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.url) || '', "\nX-TWITTER:").concat(twitter || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.twitter) || '', "\nX-LINKEDIN:").concat(linkedin || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.linkedin) || '', "\nX-THREADS:").concat(threads || (activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.threads) || '', "\nEND:VCARD\n    ").trim();
    var blob = new Blob([vCard], {
      type: 'text/vcard'
    });
    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = "".concat((activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.name) || 'contact', ".vcf");
    link.click();
  };
  var swallowEvent = function (event) {
    event.stopPropagation();
  };
  var isPersonEntity = entityTypeNameFor(activeEntity) === 'Person';
  var shouldShowEmail = !!email && (!isPersonEntity || !(activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.hideEmail));
  var shouldShowPhone = !!phone && (!isPersonEntity || !(activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.hidePhone));
  return React.createElement(My.Container, {
    className: cls.name(className),
    entity: entity
  }, React.createElement(My.Body, {
    hasContactInfo: !!hasContactInfo
  }, React.createElement(My.Head, null, shouldShowEmail && React.createElement(My.TextValue, {
    iconComponent: EmailFilledIconGlyph,
    colors: __assign(__assign({}, colors), {
      text: 'text'
    }),
    iconSize: 30
  }, email), shouldShowPhone && React.createElement(My.TextValue, {
    iconComponent: PhoneFilledIconGlyph,
    colors: __assign(__assign({}, colors), {
      text: 'text'
    }),
    iconSize: 30
  }, phone), !!twitter && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Twitter'),
    href: twitter,
    target: "_blank"
  }, React.createElement(TwitterFilledIconGlyph, {
    size: 30,
    colors: colors
  })), !!threads && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Threads'),
    href: twitter,
    target: "_blank"
  }, React.createElement(ThreadsFilledIconGlyph, {
    size: 30,
    colors: colors
  })), !!linkedin && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Linkedin'),
    href: linkedin,
    target: "_blank"
  }, React.createElement(LinkedinFilledIconGlyph, {
    size: 30,
    colors: colors
  })), !!hasWebsite && React.createElement(My.WebsiteButton, {
    colors: colors,
    href: websiteUrl,
    variant: 'micro',
    shape: 'rounded',
    borderStyle: 'solid',
    icon: ChevronRightThinIconGlyph
  }, t('Website'))), hasContactInfo && React.createElement(DottedLine, {
    height: 2,
    gap: 7,
    colors: colors
  }), React.createElement(My.Buttons, null, React.createElement(My.Download, {
    onClick: function (e) {
      e.preventDefault();
      downloadVCard();
    },
    colors: colors,
    href: '#',
    shape: 'rounded',
    borderStyle: 'solid',
    icon: ChevronRightThinIconGlyph
  }, t('Download Contact')))));
};
SliceContactInfo.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;